import FormAPI from '../../api/FormAPI';

export function getListDeclarationBoat(popkey){
  return function(dispatch){
      dispatch({type:'GET_DECLARATION_LOADING'});
    return FormAPI.getDeclarationBoat(popkey)
    .then(data=>{
      dispatch({type:'GET_DECLARATION_SUCCESS',
      payload:{
        declarations:data.data.list_declaration,
        number:data.data.number
        }
      })
    })
    .catch((error)=>{
      console.log(error);
      dispatch({type:'GET_DECLARATION_ERROR'})
    })
  }
}
